import Logo from './Logo'
import Navbar from './Navbar/Navbar'
import HeaderConfig from './HeaderConfig'
import React, {useEffect, useState} from 'react';

const Header = () => {
    const [isSticky, setIsSticky] = useState(false)

    const sticky = () => {
        const scrollTop = window.scrollY;
        scrollTop >= 250 ? setIsSticky(true) : setIsSticky(false)
    }

    useEffect(() => {
        window.addEventListener('scroll', sticky)

        return () => {
            window.removeEventListener('scroll', sticky)
        }
    }, [])

    return (
        <header className={`header-area ${isSticky ? 'sticky' : 'not-sticky'}`}>
            <div className="container-header">
                <div className="row align-items-center">
                    <div className="col-5 col-lg-2">
                        <Logo/>
                    </div>
                    
                    <div className="col d-flex justify-content-end align-items-center">
                        <Navbar/>
                        <HeaderConfig/>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;